
function askForSupportDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/ask-for-support/ask-for-support-dialog.html?$$REVISION$$'
  }
}
export { askForSupportDialog }
